/**
 * Privacy Policy Page - Suppress TrustArc Consent Banner
 */

(function() {
  'use strict';

  if (!window.location.pathname.toLowerCase().includes('privacy')) {
    return;
  }

  const style = document.createElement('style');
  style.innerHTML = `
    #consent-banner, #truste-consent-track, #consent_blackbar,
    .truste_box_overlay, .trustarc-banner-wrapper,
    [id*="truste"], [class*="truste"], [class^="tc-"], [class*=" tc-"] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(style);

  window.truste = window.truste || {};
  window.truste.cma = window.truste.cma || {};
  window.truste.cma.callApi = function() { return false; };

  const bannerSelectors = [
    '#consent-banner', '#truste-consent-track', '#consent_blackbar',
    '.truste_box_overlay', '.trustarc-banner-wrapper'
  ];

  function removeBannerElements() {
    bannerSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => el.remove());
    });

    document.querySelectorAll('[id*="truste"], [class*="truste"]').forEach(el => el.remove());
  }

  // Remove immediately
  removeBannerElements();

  // Remove after TrustArc loads (async)
  setTimeout(removeBannerElements, 100);
  setTimeout(removeBannerElements, 500);

})();
